import MuiStepper from "@mui/material/Stepper";
const Stepper = MuiStepper;
export default Stepper;
